import React, { useState } from 'react'
import styles from './GenerateTextureContentUI.module.scss'
import BigButton from '../BigButton'
import { EditPopupUI } from '../EditPopupUI/EditPopupUI'
import { NoContent } from '../../screens/NewProductUIV2/NoContent'
import { ADMIN_MY_PRODUCTS_3DMODAL_EACH_V2, ADMIN_MY_PRODUCTS_TEXTURES_EACH_V2 } from '../../constants/routePathConstants'
import { textureDetailsModalActions } from '../../redux/slicers/textureDetailsModalSlicer'
import { useDispatch } from 'react-redux'
import { useUserContext } from '../../contexts/UserContext'

const GenerateContentPopup = ({ data, show, onClose, onContentCreate, btnLoading, hideProductInfoAction, hideTextureInfoAction }) => {
    if (!show) return null;

    const {isGuestUser} = useUserContext()
    const dispatch = useDispatch()

    let isTexture = 'is_special_case_texture' in (data ?? {});
    if (!isTexture) {
        isTexture = Boolean(data?.texture_file || data?.low_texture_file)
    }
    const isModel = !isTexture || (data?.blender_id || data?.is_prop_group || data?.product_file);

    function onClick(showTextureInfo) {
        if (!showTextureInfo)
            window.open((isModel ? ADMIN_MY_PRODUCTS_3DMODAL_EACH_V2 : ADMIN_MY_PRODUCTS_TEXTURES_EACH_V2)?.replace(":id", data?.id), "_blank")
        else {
            dispatch(textureDetailsModalActions?.show(data))
            dispatch(textureDetailsModalActions?.closeGenerateContentShowModal())
        }
    }

    return (<>
        <EditPopupUI
            showDefaultHeader={true}
            showCustomHeader={false}
            hideThumbnail={true}
            show={show}
            onClose={onClose}
            // loading={loading}
            title={data?.name}
            bodyClassName={styles.body}
            className="rightSidebar leaveHeader texture-details"
            backdropClassName="hideBackdrop">
            <section className='d-flex flex-column gap-3 justify-content-center align-items-center'>
                <NoContent showTitleAndDescription={false} className={styles.noContent} hideActions={true} />
                <span className={styles.title}>No experience page</span>
                <span className={styles.subtitle}>Click on the button below to generate visuals for your {isModel?'product':'texture'}.</span>
                <BigButton isLoading={btnLoading} className={styles.createButton} variant="dark" onClick={onContentCreate}>+ Generate Visuals</BigButton>
                {!hideProductInfoAction ? <span onClick={() => onClick(false)} className={styles.primary}>View experience page</span> : null}
                {!isGuestUser() && !isModel && !hideTextureInfoAction ? <span onClick={() => onClick(true)} className={styles.primary}>View texture info</span> : null}
            </section>

        </EditPopupUI>
    </>)
}

export default GenerateContentPopup